import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'EmployeeSearch2' })
export class EmployeeSearch2Pipe implements PipeTransform {
  transform(value, args?): Array<any> {
    const searchText = new RegExp(args, 'ig');
    if (value) {
      return value.filter(employee => {
        if (employee.fullName || employee.employeeId) {
          if (employee.fullName.search(searchText) !== -1 || employee.employeeId.search(searchText) !== -1)  {
            return true;
          }
          return false;
        }
        return false;
      });
    }
    return [];
  }
}
